// src/utils/adminPendingApi.js
//
// What waits for an admin behind each button (backend routes/adminPending.ts,
// admins only): { lists: { review, reportedLists, reportedComments,
// photosReview, reportedPhotos, total }, commercial: { prospects, visits, total } }.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export async function pendingCounts(token) {
  const r = await fetch(`${API_BASE_URL}/admin/pending`, { headers: { Authorization: `Bearer ${token}` } });
  if (!r.ok) throw new Error(`HTTP_${r.status}`);
  return r.json();
}
